import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Who,
  HeroMediaKitCover,
  Benefits,
  Metrics,
  Values,
  Pricing,
  AreYouReady,
} from './components';

const LandingMediaKitEnProduccionConMem = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Who themeMode={themeMode} />
      </Container>
      <Container>
        <HeroMediaKitCover />
      </Container>
      <Container>
        <Benefits />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <Values />
      </Container>
      <Container>
        <Pricing />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitEnProduccionConMem.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKitEnProduccionConMem;
